'use strict'
const merge = require('webpack-merge')
const devEnv = require('./dev.env')

module.exports = merge(devEnv, {
  NODE_ENV: '"testing"'
})



//////////////////
// WEBPACK FOOTER
// ./config/test.env.js
// module id = WXia
// module chunks = 1